import React from "react";
import { UserThread } from "./template_types/user";
import type { ConversationResponse, BaseMessage } from "./types";

interface Props {
  conversation: ConversationResponse;
}

interface Thread {
  user: BaseMessage;
  synthesizer?: BaseMessage;
  tools: BaseMessage[];
}

export default function ConversationView({
  conversation,
}: Props) {
  const messages = [...conversation.conversation_messages].sort(
    (a, b) => Number(a.id) - Number(b.id),
  );

  if (messages.length === 0) return null;

  // Group messages by user message (parent_id)
  const threads: Thread[] = messages
    .filter((m) => m.template_type === "user")
    .map((user) => ({
      user,
      synthesizer: messages.find(
        (m) => m.parent_id === user.id && m.template_type === "synthesizer",
      ),
      tools: messages
        .filter((m) => m.parent_id === user.id && m.template_type === "tool")
        .sort((a, b) => Number(a.id) - Number(b.id)),
    }));

  return (
    <div className="flex flex-col space-y-6">
      {threads.map((thread) => (
        <UserThread
          key={thread.user.id}
          {...thread}
        />
      ))}
    </div>
  );
}
